import { PlatformType, PlatformParams, Cafe24Params, SmartstoreParams, ShopbyParams } from './types';

export const getPlatformTypeFromParams = (searchParams: URLSearchParams): PlatformType | null => {
  // cafe24 체크: mallId, shopNo, cafe24UserId, cafe24_auth_url 중 하나라도 있으면 cafe24
  if (
    searchParams.has('mallId') ||
    searchParams.has('shopNo') ||
    searchParams.has('cafe24UserId') ||
    searchParams.has('cafe24_auth_url')
  ) {
    return 'cafe24';
  }

  // 스마트스토어 체크: naverStoreAccountUid, naverStoreAccountRole 중 하나라도 있으면 smartstore
  if (searchParams.has('naverStoreAccountUid') || searchParams.has('naverStoreAccountRole')) {
    return 'smartstore';
  }

  // 샵바이 체크: shopbyMallNo, shopbyUserId 중 하나라도 있으면 shopby
  if (searchParams.has('shopbyMallNo') || searchParams.has('shopbyUserId')) {
    return 'shopby';
  }

  return null;
};

export const extractPlatformParams = (
  searchParams: URLSearchParams,
  platformType: PlatformType,
): PlatformParams | null => {
  switch (platformType) {
    case 'cafe24': {
      const mallId = searchParams.get('mallId') || '';
      const shopNo = searchParams.get('shopNo') || '';
      const cafe24UserId = searchParams.get('cafe24UserId') || '';
      const cafe24_auth_url = searchParams.get('cafe24_auth_url') || '';

      return {
        mallId,
        shopNo,
        cafe24UserId,
        cafe24_auth_url,
      } as Cafe24Params;
    }

    case 'smartstore': {
      const naverStoreAccountUid = searchParams.get('naverStoreAccountUid') || '';
      const naverStoreAccountRole = searchParams.get('naverStoreAccountRole') || '';

      return {
        naverStoreAccountUid,
        naverStoreAccountRole,
      } as SmartstoreParams;
    }

    case 'shopby': {
      const shopbyMallNo = searchParams.get('shopbyMallNo') || '';
      const shopbyUserId = searchParams.get('shopbyUserId') || '';

      return {
        shopbyMallNo,
        shopbyUserId,
      } as ShopbyParams;
    }

    default:
      return null;
  }
};
